import { render, staticRenderFns } from "./BackgroundsPageBreadcrumbs.vue?vue&type=template&id=30a88339&scoped=true&"
import script from "./BackgroundsPageBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./BackgroundsPageBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundsPageBreadcrumbs.vue?vue&type=style&index=0&id=30a88339&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a88339",
  null
  
)

export default component.exports